export const Footer = () => {
  const socialLinks = [
    {
      name: 'GitHub',
      url: 'https://github.com/shreyas-debug',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/shreyas-satpute-5817b41b3/',
    },
  ];

  return (
    <footer 
      id="footer"
      className="footer"
      style={{
        padding: '80px 0 60px',
        backgroundColor: 'transparent',
        borderTop: 'none'
      }}
    >
      <div className="container" style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '0 24px' 
      }}>
        <div className="footer-content" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '32px'
        }}>
          {/* Main CTA */}
          <h2 style={{
            fontSize: 'clamp(24px, 4vw, 32px)',
            fontFamily: "var(--font-display)",
            fontWeight: '700',
            color: 'var(--text-primary)',
            marginBottom: '8px'
          }}>
            Looking for a developer?
          </h2>
          
          <p className="footer-copyright" style={{
            fontSize: '18px',
            color: 'var(--text-secondary)',
            maxWidth: '440px',
            lineHeight: '1.7',
            margin: 0
          }}>
            Building something that needs a backend engineer who's shipped at scale?{' '}
            <span style={{ color: 'var(--accent)' }}>Let's talk.</span>
          </p>

          {/* Social Links */}
          <div style={{
            display: 'flex',
            gap: '24px',
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: "var(--font-reading)",
                  fontSize: '14px',
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  padding: '8px 0',
                  borderBottom: '1px solid transparent',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = 'var(--accent)';
                  e.currentTarget.style.borderBottomColor = 'var(--accent)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'var(--text-secondary)';
                  e.currentTarget.style.borderBottomColor = 'transparent';
                }}
              >
                {social.name === 'GitHub' && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.2c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
                    <path d="M9 18c-4.51 2-5-2-7-2" />
                  </svg>
                )}
                {social.name === 'LinkedIn' && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                    <rect width="4" height="12" x="2" y="9" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                )}
                {social.name === 'Email' && (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                )}
                {social.label || social.name}
              </a>
            ))}
          </div>

          {/* Email CTA */}
          <a 
            href="mailto:satputeshreyas07@gmail.com"
            style={{
              fontFamily: "var(--font-reading)",
              fontSize: '14px',
              fontWeight: '500',
              padding: '12px 24px',
              backgroundColor: 'var(--accent)',
              color: 'var(--bg-primary)',
              border: 'none',
              borderRadius: '8px',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.backgroundColor = 'var(--accent-hover)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.backgroundColor = 'var(--accent)';
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            Get in touch
          </a>

          {/* Divider */}
          <div style={{
            width: '60px',
            height: '1px',
            backgroundColor: 'var(--border-color)',
            marginTop: '16px'
          }} />

          {/* Copyright */}
          <p style={{
            fontSize: '13px',
            color: 'var(--text-muted)',
            margin: 0,
            fontFamily: "var(--font-reading)",
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
            © 2026 Shreyas Satpute
          </p>
        </div>
      </div>
    </footer>
  );
};
